import type { KubernetesResourceManifestDiffResource, KubernetesResourceManifestSummaryResource } from "@octopusdeploy/octopus-server-client";
export function getManifestSummaryForDeployment(diffResource: KubernetesResourceManifestDiffResource, deploymentId: string): KubernetesResourceManifestSummaryResource | undefined {
    switch (diffResource.DiffResult) {
        case "Unchanged":
            return diffResource.KubernetesResourceManifest.DeploymentId === deploymentId ? diffResource.KubernetesResourceManifest : undefined;
        case "Added":
            return diffResource.KubernetesResourceManifest.DeploymentId === deploymentId ? diffResource.KubernetesResourceManifest : undefined;
        case "Removed":
            return diffResource.KubernetesResourceManifest.DeploymentId === deploymentId ? diffResource.KubernetesResourceManifest : undefined;
        case "Changed":
            //changed should only ever show up in the current execution
            return diffResource.ToKubernetesResourceManifest.DeploymentId === deploymentId ? diffResource.ToKubernetesResourceManifest : undefined;
    }
}
